import { AxiosResponse } from 'axios';
import apiClient from '../lib/apiClient';

// comsched는 wm 서버가 부른다. 키는 서버의 Secret에 있고 브라우저로 내보내지 않는다.

export interface ChainedStep {
    order: number;
    apiId: number;
    authType: 'NONE' | 'SYSTEM';
    // 쿼리 파라미터 (URL 뒤에 붙음)
    queryParamMapping?: Record<string, string>;
    staticQueryParams?: string;
    // 바디 데이터 (JSON 본문)
    bodyParamMapping?: Record<string, string>;
    staticBodyParams?: string;
    // 실행 조건
    runCondition?: {
        target: string;
        operator: 'NOT_EMPTY';
    };
}

export interface ScheduleRequest {
    jobName: string;
    jobGroup: string;
    jobType: 'ONCE' | 'RECURRING';
    fireTime?: string;
    cronExpression?: string;
    callerId: string;
    callerUserId: string;
    actionType: 'MESSAGE_BROKER' | 'REST_API' | 'CHAINED_REST_API'; // ✨ 타입 추가
    chainedSteps?: ChainedStep[]; // ✨ 단계별 설정 추가
    apiId?: number;
    destination?: string;
    messageBody?: string;
    customQueryParams?: string;
    customBodyParams?: string;
    description?: string;
}

export interface ScheduleResponse {
    jobName: string;
    jobGroup: string;
    jobType: string;
    triggerState: string;
    nextFireTime: string;
    cronExpression?: string;
    jobData: {
        message: string;
        [key: string]: any;
    };
    actionType: 'MESSAGE_BROKER' | 'REST_API' | 'CHAINED_REST_API';
    description?: string;
}

// 스케줄 생성
export const createSchedule = (data: ScheduleRequest): Promise<AxiosResponse> => {
    return apiClient.post('/scheduler/create', data);
};

// 스케줄 목록 조회. 사용자는 서버가 토큰에서 정한다
export const getScheduleList = (): Promise<AxiosResponse<ScheduleResponse[]>> => {
    return apiClient.get('/scheduler/list');
};

// 스케줄 삭제
export const deleteSchedule = (jobName: string, jobGroup: string): Promise<AxiosResponse> => {
    return apiClient.delete('/scheduler/delete', {
        params: { jobName, jobGroup },
    });
};